import { render, staticRenderFns } from "./SelectAdress.vue?vue&type=template&id=39421f37&scoped=true"
import script from "./SelectAdress.vue?vue&type=script&lang=js"
export * from "./SelectAdress.vue?vue&type=script&lang=js"
import style0 from "./SelectAdress.vue?vue&type=style&index=0&id=39421f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39421f37",
  null
  
)

export default component.exports